export default __webpack_public_path__ + "images/Three_Vessel_View_Trachea.9cec81f7cff1386fad85774c829a7fa9.png";